import { Form, Icon, Modal, Select } from 'antd';
import styles from './WithModalRoomDdy.module.scss';
import React from 'react';
import DispexInput from '../../../../../components/DispexInput';
import { useSelector } from 'react-redux';
import useChangeAttributes from '../../../mutations/useChangeAttributes';
import useAddressTypeFinishQuery from '../../../queries/useAddressTypeFinishQuery';
import moment from 'moment';
import { DatePickerCustom } from '../../../../../components/DatePickerCustom';

const { Option, OptGroup } = Select;

const WithModalRoomDdyNode = ({ form, visible, onClickClose }) => {
  const { getFieldDecorator, validateFields } = form;

  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const { mutateAsync, isLoading } = useChangeAttributes();

  const { data, isFetching } = useAddressTypeFinishQuery();

  const handleSubmit = (e) => {
    e.preventDefault();

    validateFields(async (err, values) => {
      if (!err) {
        await mutateAsync({
          ...values,
          addressId: currentFlat?.addressId,
          houseId: currentFlat?.houseId,
        });

        onClickClose();
      }
    });
  };

  const buildTree = (list = []) => {
    const parents = list?.filter((item) => !item.parentId);
    const childrenByParent = list?.reduce((acc, item) => {
      if (item.parentId) {
        acc[item.parentId] = acc[item.parentId] || [];
        acc[item.parentId].push(item);
      }
      return acc;
    }, {});
    return { parents, childrenByParent };
  };

  const { parents, childrenByParent } = buildTree(data);

  return (
    <Modal
      title="Изменение характеристик помещения"
      closable
      onCancel={onClickClose}
      destroyOnClose
      visible={visible}
      okText={isLoading ? <Icon type="loading" /> : 'Сохранить'}
      onOk={handleSubmit}
      width={750}
    >
      <Form>
        <div className={styles.root}>
          <div className={styles.firstRow}>
            <Form.Item label="Номер помещения по ДДУ" className={styles.item}>
              {getFieldDecorator('addressDdu', {
                initialValue: currentFlat?.address?.addressDdu || undefined,
              })(<DispexInput style={{ height: '40px', width: '100%' }} />)}
            </Form.Item>
            <Form.Item
              label="Дата подписания Акта приема-передачи"
              className={styles.item}
            >
              {getFieldDecorator('dateSignAct', {
                initialValue: currentFlat?.address?.dateSignAct
                  ? moment(currentFlat?.address?.dateSignAct)
                  : undefined,
              })(<DatePickerCustom style={{ width: '100%' }} size="large" />)}
            </Form.Item>
          </div>
          <div className={styles.firstRow}>
            <Form.Item label="Номер ДДУ" className={styles.item}>
              {getFieldDecorator('numberDdu', {
                initialValue: currentFlat?.address?.numberDdu || undefined,
              })(<DispexInput style={{ height: '40px', width: '100%' }} />)}
            </Form.Item>
            <Form.Item label="Дата ДДУ" className={styles.item}>
              {getFieldDecorator('dateDdu', {
                initialValue: currentFlat?.address?.dateDdu
                  ? moment(currentFlat?.address?.dateDdu)
                  : undefined,
              })(<DatePickerCustom style={{ width: '100%' }} size="large" />)}
            </Form.Item>
          </div>
          <div className={styles.firstRow}>
            <Form.Item label=" Вид отделки" className={styles.item}>
              {getFieldDecorator('addressTypeFinishId', {
                initialValue:
                  currentFlat?.address?.addressTypeFinishId || undefined,
              })(
                <Select loading={isFetching} className={styles.customSelect}>
                  {parents.map((parent) => {
                    const children = childrenByParent[parent.id] || [];

                    if (children.length === 0) {
                      return (
                        <Option key={parent.id} value={parent.id}>
                          {parent.name}
                        </Option>
                      );
                    }

                    return (
                      <OptGroup key={parent.id} label={parent.name}>
                        <Option value={parent.id}>{parent.name}</Option>
                        {children.map((child) => (
                          <Option key={child.id} value={child.id}>
                            {child.name}
                          </Option>
                        ))}
                      </OptGroup>
                    );
                  })}
                </Select>
              )}
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

const WithModalRoomDdy = Form.create('ddy-form')(WithModalRoomDdyNode);
export default WithModalRoomDdy;
